import PaySelect from './PaySelect';
export default PaySelect;



// WEBPACK FOOTER //
// ./src/components/atomic/molecules/PaySelect/index.js